var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_salva",
    "data-name": "icona salva",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_312",
    "data-name": "Tracciato 312",
    d: "M16.944,18.5H6.056A1.556,1.556,0,0,1,4.5,16.944V6.056A1.556,1.556,0,0,1,6.056,4.5h8.556L18.5,8.389v8.556A1.556,1.556,0,0,1,16.944,18.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_313",
    "data-name": "Tracciato 313",
    d: "M18.278,25.722V19.5H10.5v6.222",
    transform: "translate(-7.389 -11.722)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_314",
    "data-name": "Tracciato 314",
    d: "M10.5,4.5V8.389h6.222",
    transform: "translate(-7.389 -4.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.75addba773b97db13dcf1c19be92cd52.svg";
export { ForwardRef as ReactComponent };